<template>
  <div class="read-me-page">
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row class="main-content">
      <el-col :span="4" class="menu-col">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20" class="content-col">
        <!-- 顶部提示横幅 -->
        <div class="notice-banner">
          <i class="el-icon-info-filled"></i>
          <span>本平台知晓国家法律，不会泄露用户填写的任何资料，且不会用于数据分析和广告商业业务。对于高度隐私信息，请用户收集完后自行删除。</span>
        </div>

        <!-- 主要内容卡片 -->
        <div class="content-wrapper">
          <!-- 快速入口区 -->
          <div class="quick-start-section">
            <h2 class="section-title">
              <i class="el-icon-question-filled"></i>
              常见问题
            </h2>
            <div class="faq-grid">
              <div class="faq-card">
                <div class="faq-icon">
                  <i class="el-icon-document"></i>
                </div>
                <h3>已有表格能否使用？</h3>
                <p>可以把您的表格导入系统中。用户填写好数据后，导出数据并粘贴到您的表格中，即可完成数据收集工作。</p>
                <el-button type="primary" size="small" class="btn-primary-custom" @click="goToImport">
                  <i class="el-icon-upload2"></i> 去导入
                </el-button>
              </div>

              <div class="faq-card">
                <div class="faq-icon">
                  <i class="el-icon-edit"></i>
                </div>
                <h3>没有表格能否使用？</h3>
                <p>可以根据自己的需要制作一张收集表发给大家填写。用户填写好数据后导出数据即可。</p>
                <el-button type="primary" size="small" class="btn-primary-custom" @click="goToMakeForm">
                  <i class="el-icon-plus"></i> 去制作
                </el-button>
              </div>

              <div class="faq-card highlight">
                <div class="faq-icon support">
                  <i class="el-icon-service"></i>
                </div>
                <h3>如何获得客服支持？</h3>
                <p>有问题直接在小程序的客服里咨询，或添加微信联系。</p>
                <div class="contact-info">
                  <div class="contact-item">
                    <i class="el-icon-chat-dot-round"></i>
                    <span>微信：wx34424698</span>
                  </div>
                  <div class="contact-item">
                    <i class="el-icon-phone"></i>
                    <span>电话：19909408114</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 详细问答区 -->
          <div class="detail-qa-section">
            <h2 class="section-title">
              <i class="el-icon-chat-line-square"></i>
              使用技巧
            </h2>
            <div class="qa-list">
              <div class="qa-item">
                <div class="qa-question">
                  <span class="q-badge">Q1</span>
                  <span class="q-text">表格中已有部分数据，需要填表人填写部分数据，怎么操作？</span>
                </div>
                <div class="qa-answer">
                  <span class="a-badge">A</span>
                  <span class="a-text">将表格中的数据导入系统，把一到两列设置为<strong>领表凭证</strong>（如姓名、编号等），填表人录入凭证就可以领到自己应该填写的数据进行填写。</span>
                </div>
              </div>

              <div class="qa-item">
                <div class="qa-question">
                  <span class="q-badge">Q2</span>
                  <span class="q-text">能让一些数据不让修改吗，怎么操作？</span>
                </div>
                <div class="qa-answer">
                  <span class="a-badge">A</span>
                  <span class="a-text">导入数据时把列名属性中的<strong>"能否修改"</strong>设为<strong>"禁止填表人修改"</strong>即可。</span>
                </div>
              </div>
            </div>
          </div>

          <!-- 功能特性展示 -->
          <div class="features-section">
            <h2 class="section-title">
              <i class="el-icon-star-on"></i>
              平台特性
            </h2>
            <div class="features-grid">
              <div class="feature-item">
                <div class="feature-icon safe">
                  <i class="el-icon-lock"></i>
                </div>
                <span class="feature-text">数据安全</span>
              </div>
              <div class="feature-item">
                <div class="feature-icon fast">
                  <i class="el-icon-lightning"></i>
                </div>
                <span class="feature-text">快速收集</span>
              </div>
              <div class="feature-item">
                <div class="feature-icon easy">
                  <i class="el-icon-magic-stick"></i>
                </div>
                <span class="feature-text">简单易用</span>
              </div>
              <div class="feature-item">
                <div class="feature-icon free">
                  <i class="el-icon-present"></i>
                </div>
                <span class="feature-text">免费使用</span>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'
  import '../assets/global.css'

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {
      }
    },
    mounted() {
    },
    created() {
    },
    methods: {
      goToImport() {
        this.$router.push('/import_data_excel')
      },
      goToMakeForm() {
        this.$router.push('/make_form')
      }
    },
    watch: {
    }
  }
</script>

<style scoped>
  /* 页面整体 */
  .read-me-page {
    min-height: 100vh;
    background: #f5f7fa;
  }

  .main-content {
    padding: 20px;
  }

  .content-col {
    padding-left: 20px;
  }

  /* 顶部提示横幅 */
  .notice-banner {
    background: linear-gradient(135deg, #fff3cd 0%, #ffeeba 100%);
    border-left: 4px solid #ffc107;
    border-radius: 10px;
    padding: 16px 20px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 14px;
    color: #856404;
  }

  .notice-banner i {
    font-size: 20px;
    color: #ffc107;
    flex-shrink: 0;
  }

  /* 内容包装器 */
  .content-wrapper {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  /* 区块标题 */
  .section-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin: 0 0 20px;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .section-title i {
    color: #1485FB;
    font-size: 22px;
  }

  /* 快速入口区 */
  .quick-start-section {
    background: #fff;
    border-radius: 12px;
    padding: 25px;
    box-shadow: 0 2px 12px rgba(0,0,0,0.04);
  }

  .faq-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
  }

  .faq-card {
    background: linear-gradient(135deg, #f8f9fa 0%, #fff 100%);
    border-radius: 12px;
    padding: 25px;
    text-align: center;
    border: 1px solid #e9ecef;
    transition: all 0.3s ease;
  }

  .faq-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 25px rgba(0,0,0,0.1);
  }

  .faq-card.highlight {
    background: linear-gradient(135deg, #e6f7ff 0%, #f0f9ff 100%);
    border-color: #1485FB;
  }

  .faq-icon {
    width: 60px;
    height: 60px;
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 15px;
  }

  .faq-icon.support {
    background: linear-gradient(135deg, #2CCB92 0%, #25b582 100%);
  }

  .faq-icon i {
    font-size: 28px;
    color: #fff;
  }

  .faq-card h3 {
    font-size: 16px;
    color: #333;
    margin: 0 0 12px;
  }

  .faq-card p {
    font-size: 13px;
    color: #666;
    line-height: 1.6;
    margin: 0 0 15px;
  }

  .btn-primary-custom {
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    border: none;
    border-radius: 6px;
    transition: all 0.3s ease;
  }

  .btn-primary-custom:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(20, 133, 251, 0.3);
  }

  .contact-info {
    text-align: left;
    background: rgba(255,255,255,0.7);
    padding: 12px 15px;
    border-radius: 8px;
  }

  .contact-item {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    color: #555;
    margin-bottom: 8px;
  }

  .contact-item:last-child {
    margin-bottom: 0;
  }

  .contact-item i {
    color: #1485FB;
    font-size: 14px;
  }

  /* 详细问答区 */
  .detail-qa-section {
    background: #fff;
    border-radius: 12px;
    padding: 25px;
    box-shadow: 0 2px 12px rgba(0,0,0,0.04);
  }

  .qa-list {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .qa-item {
    background: #f8f9fa;
    border-radius: 10px;
    padding: 20px;
    border-left: 4px solid #1485FB;
  }

  .qa-question {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    margin-bottom: 12px;
  }

  .q-badge {
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    color: #fff;
    padding: 4px 10px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
    flex-shrink: 0;
  }

  .q-text {
    font-size: 15px;
    font-weight: 600;
    color: #333;
    line-height: 1.5;
  }

  .qa-answer {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding-left: 8px;
  }

  .a-badge {
    background: linear-gradient(135deg, #2CCB92 0%, #25b582 100%);
    color: #fff;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 600;
    flex-shrink: 0;
  }

  .a-text {
    font-size: 14px;
    color: #555;
    line-height: 1.6;
  }

  .a-text strong {
    color: #1485FB;
  }

  /* 功能特性区 */
  .features-section {
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    border-radius: 12px;
    padding: 25px;
    box-shadow: 0 4px 20px rgba(20, 133, 251, 0.2);
  }

  .features-section .section-title {
    color: #fff;
    margin-bottom: 25px;
  }

  .features-section .section-title i {
    color: #FFCB2F;
  }

  .features-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
  }

  .feature-item {
    background: rgba(255,255,255,0.15);
    backdrop-filter: blur(10px);
    border-radius: 12px;
    padding: 20px;
    text-align: center;
    transition: all 0.3s ease;
  }

  .feature-item:hover {
    background: rgba(255,255,255,0.25);
    transform: translateY(-3px);
  }

  .feature-icon {
    width: 50px;
    height: 50px;
    background: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 12px;
  }

  .feature-icon i {
    font-size: 24px;
  }

  .feature-icon.safe i {
    color: #52c41a;
  }

  .feature-icon.fast i {
    color: #faad14;
  }

  .feature-icon.easy i {
    color: #1890ff;
  }

  .feature-icon.free i {
    color: #eb2f96;
  }

  .feature-text {
    color: #fff;
    font-size: 14px;
    font-weight: 500;
  }

  /* 响应式 */
  @media (max-width: 1200px) {
    .faq-grid {
      grid-template-columns: repeat(2, 1fr);
    }

    .features-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (max-width: 768px) {
    .main-content {
      padding: 10px;
    }

    .content-col {
      padding-left: 0;
      margin-top: 15px;
    }

    .faq-grid {
      grid-template-columns: 1fr;
    }

    .features-grid {
      grid-template-columns: repeat(2, 1fr);
    }

    .section-title {
      font-size: 16px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/read_me.vue